/**
 * @file        src/components/NeonWordmark.jsx
 * @description Compatibility shim. The Beyond Destination fork replaced the old
 *              SVG wordmark; several places (voucher, voucher modal, loading
 *              modal, legal doc) still import this name. It now renders the REAL
 *              brand logo via <BrandLogo> (/public/logo.png), forwarding
 *              `className` for sizing. These surfaces are white/paper, so the
 *              logo's dark "Destination" text reads cleanly. New code should
 *              import BrandLogo directly.
 * @author      Kinetika Labs
 * @created     2026-06-23
 * @changelog
 *   - 2026-06-23 Claude — Initial. Extracted from Sidebar so the booking
 *                          voucher can show the real logo.
 *   - 2026-07-21 Claude — Beyond Destination fork: shim over BeyondWordmark.
 *   - 2026-07-22 Claude — Now renders the real logo via <BrandLogo>.
 *   - 2026-08-04 Claude — Defaults to the shared LOGO_SIZE; the four call sites
 *                          dropped their per-site w-[132px]…w-[160px] widths.
 */
import React from 'react';
import BrandLogo, { LOGO_SIZE } from './BrandLogo.jsx';

export default function NeonWordmark({ className = LOGO_SIZE }) {
  return <BrandLogo className={className} full colorClassName="text-ink" />;
}
